// extracted by mini-css-extract-plugin
export default {"root":"root__E3TPid3v","popover":"popover__NVRo0Tha"};